import React from 'react';

import { Spin } from 'antd';

import { useImageValidation } from './imageValidation';

/**
 * Componente de fallback para quando a imagem não está disponível
 */
export const ImageFallback: React.FC<{ size?: number }> = ({ size = 180 }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#666',
        fontSize: '14px',
      }}
    >
      Sem imagem
    </div>
  );
};

/**
 * Componente de imagem com validação e fallback
 */
export const ValidatedImage: React.FC<{
  src: string | null;
  alt: string;
  size?: number;
  style?: React.CSSProperties;
}> = ({ src, alt, size = 180, style }) => {
  const { isValid, isLoading } = useImageValidation(src);

  if (isLoading) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="small" />
      </div>
    );
  }

  if (!isValid || !src) {
    return <ImageFallback size={size} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
        ...style,
      }}
      onError={() => {
        console.error(`Erro ao carregar imagem: ${src}`);
      }}
    />
  );
};
